import React, { useState } from "react";
import { Avatar, Button, Badge } from "antd";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { StarFilled } from "@ant-design/icons";
import Moment from "react-moment";
import moment from "moment";
import ContextMenu from "components/ContextMenu/ContextMenu";
import { getToken } from "services/token-service/token.service";
import { useClaimConversation } from "pages/AgentView/api/conversations";
import { key as StockCountKey } from "../../services/hooks/usegetStockCount";
import { key as StockMessagesKey } from "../../services/hooks/useGetStock";
import NOIMAGE from "assets/images/no_image.jpeg";

// eslint-disable-next-line no-unused-vars
import Pusher from "pusher-js";

import "./ConversationItem.scss";
import { queryClient } from "../../App";
const ConversationItem = (props) => {
  const { conversationData, buttonType } = props;
  const [popup, setPopup] = useState({
    visible: false,
    x: 0,
    y: 0,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const { mutate: claimConversationMutate } = useClaimConversation();
  const token = getToken();

  moment.updateLocale("en", {
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "%d s",
      ss: "%d s",
      m: "1min",
      mm: "%d min",
      h: "1h",
      hh: "%dh",
      d: "1 day",
      dd: "%d day",
      w: "1 week",
      ww: "%d2",
      M: "1m",
      MM: "%dm",
      y: "1y",
      yy: "%d y",
    },
  });
  const claimConversation = (event) => {
    const convId = conversationData.id;
    claimConversationMutate(
      { id: convId, token },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(StockMessagesKey).then(()=>queryClient.invalidateQueries(StockCountKey).then(() =>
            navigate(`/agentView/${conversationData.id}`, {
              state: { prevPath: location.pathname },
            })
          ))
        },
      }
    );
  };

  return (
    <div className="ConversationItem">
      <div className="SingleItem ClaimButton">
        {buttonType === "claim" ? (
          <Button
            disabled={!conversationData.claimable}
            onClick={claimConversation}
          >
            Claim
          </Button>
        ) : buttonType === "readClaimed" ? (
          <Button onClick={claimConversation}>Read</Button>
        ) : (
          <Button
            onClick={claimConversation}
            onContextMenu={(event) => {
              event.preventDefault();
              if (!popup.visible) {
                document.addEventListener(`click`, function onClickOutside() {
                  setPopup({ visible: false });
                  document.removeEventListener(`click`, onClickOutside);
                });
              }

              setPopup({
                // record: <div onClick={openNewTab}>Open in new Tab</div>,
                record: (
                  <Link
                    target={"_blank"}
                    to={{
                      pathname: `/agentView/${conversationData.id}`,
                      state: { prevPath: location.pathname },
                    }}
                  >
                    Open in new Tab
                  </Link>
                ),
                visible: true,
                x: event.clientX,
                y: event.clientY,
              });
            }}
          >
            Read
          </Button>
        )}
        <ContextMenu {...popup} />
      </div>
      <div className="SingleItem MessagePreview">
        {conversationData.latest_message_body}
      </div>
      <div className="SingleItem UserInfo">
        <div>
          <Avatar src={conversationData.fictitious_profile.profile_image} />
        </div>
        <div>{conversationData.fictitious_profile.username}</div>
      </div>
      <div className="SingleItem UserInfo">
        <div>
          {conversationData.user_profile.profile_image ? (
            <Avatar
              src={`${conversationData.user_profile.profile_image}?token=${token}`}
            />
          ) : (
            <Avatar src={`${NOIMAGE}`} />
          )}
        </div>
        <div>{conversationData.user_profile.username}</div>
      </div>
      <div className="SingleItem PremiumStatus">
        {conversationData.user_profile.premium && <StarFilled />}
      </div>
      <div className="SingleItem TimeInfo">
        {conversationData.user_profile.online_status ? (
          <Badge color="green" />
        ) : (
          <Badge color="grey" />
        )}
        <Moment fromNow ago>
          {moment
            .utc(conversationData.latest_message_created_at)
            .local()
            .format()}
        </Moment>
      </div>
    </div>
  );
};

export default ConversationItem;
